/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from 'antd';
import classes from './SectionMenu.module.scss';
import { useEffect, useState, useRef } from 'react';
import GlobalViewAction from './GlobalViewAction';
import { useDispatch, useSelector } from 'react-redux';
import { Fade } from 'react-awesome-reveal';
import { setActiveSectionTab } from 'store/customer/customerViewSlice';

const SectionMenu = (props) => {
  const { menuItems = [] } = props;

  const scrollref = useRef(null);
  const [showLeftButton, setshowLeftButton] = useState(true);
  const [showRightButton, setshowRightButton] = useState(true);
  const dispatch = useDispatch();

  const activeSectionTab = useSelector(
    (state) => state?.CustomerView?.activeSectionTab
  );

  useEffect(() => {
    updateScrollButtons();
    const currentReff = scrollref.current;
    if (currentReff) {
      currentReff.addEventListener('scroll', updateScrollButtons);
    }
    return () => {
      if (currentReff) {
        currentReff.removeEventListener('scroll', updateScrollButtons);
      }
    };
  }, []);

  const scrollfun = (dir) => {
    if (scrollref.current) {
      const scrollAmount = dir === 'left' ? -500 : 500;
      scrollref.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const updateScrollButtons = () => {
    const { scrollLeft, scrollWidth, clientWidth } = scrollref.current;
    if (scrollref.current) {
      setshowLeftButton(scrollLeft > 0);
      setshowRightButton(scrollLeft < scrollWidth - clientWidth - 1.2);
    }
  };

  const handleTabChange = (key) => {
    dispatch(setActiveSectionTab(key));
  };

  return (
    <>
      <div className={classes['section-container']}>
        <div className='d-flex flex-column w-100'>
          <GlobalViewAction />
          {/* scrolling Section menu */}
          <div className='d-flex w-100 m-0 p-0 '>
            <div>
              {showLeftButton && (
                <i
                  className={`${classes['left-right-arrow']} icon icon__chevron-blue left  mt-3`}
                  onClick={() => scrollfun('left')}></i>
              )}
            </div>
            <div
              ref={scrollref}
              className={classes['scroll-container']}>
              <Tabs
                activeKey={activeSectionTab}
                onChange={handleTabChange}
                className={`${classes['menuContainer']} left-sections animate__animated animate__fadeIn`}
                type='line'
                tabPosition='top'
                items={menuItems}
                destroyOnHidden={true}
              />
            </div>
            <div>
              {showRightButton && (
                <i
                  className={`${classes['left-right-arrow']} icon icon__chevron-blue right  mt-3 `}
                  onClick={() => scrollfun('right')}></i>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Section components rendering */}
      {menuItems.map((item) => (
        <Fade
          key={item.key}
          className={classes['no-animation-fill']}>
          <div
            className={'full-width-in-container'}
            style={{
              display: item.key === activeSectionTab ? 'block' : 'none',
            }}>
            {item.component}
          </div>
        </Fade>
      ))}
    </>
  );
};

export default SectionMenu;
